import React, { useContext, useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { Container, Row, Col, Card, Form, Table, Badge } from 'react-bootstrap';
import { FaSearch, FaFilter, FaEllipsisV } from 'react-icons/fa';
import '../../../../assets/css/admin/dashboard/AllUsers.css';
import AdminLayout from '../../../../layouts/admin/AdminLayout';
import AppContext from '../../../../context/AppContext';
import axios from 'axios';

/* Menu ka ek item (hover effect ke sath) */
const MenuItem = ({ label, color, onClick }) => {
  const [hover, setHover] = useState(false);
  return (
    <div
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        padding: '10px 15px',
        borderRadius: 8,
        fontSize: '0.9rem',
        fontFamily: "'Poppins', sans-serif",
        cursor: 'pointer',
        color: color || '#2c3e50',
        background: hover ? '#eff8f7' : 'transparent',
        transition: 'background 0.2s ease',
      }}
    >
      {label}
    </div>
  );
};

const AllUsers = () => {

  const [users,        setUsers]        = useState([]);
  const [searchTerm,   setSearchTerm]   = useState(''   );
  const [statusFilter, setStatusFilter] = useState('all');
  const [pageLoading,  setPageLoading]  = useState(true);
  const [menu,         setMenu]         = useState(null); // { id, top, left }

  const { baseUrl } = useContext(AppContext);

  const fetchAll = () => {
    axios.get(`${baseUrl}/admin/users/fetchAll`)
    .then((res) => {
      if (res.data.success === true) {
        setUsers(res.data.customers);
      }
      setPageLoading(false);
    })
    .catch((err) => {
      console.log(err);
      setPageLoading(false);
    });
  };

  useEffect(() => {
    fetchAll();
  }, []);

  /* Bahar click / scroll / resize par menu band ho jaye */
  useEffect(() => {
    const closeMenu = () => setMenu(null);
    document.addEventListener('click', closeMenu);
    window.addEventListener('scroll', closeMenu, true);
    window.addEventListener('resize', closeMenu);
    return () => {
      document.removeEventListener('click', closeMenu);
      window.removeEventListener('scroll', closeMenu, true);
      window.removeEventListener('resize', closeMenu);
    };
  }, []);

  const openMenu = (e, id) => {
    e.stopPropagation();
    if (menu && menu.id === id) {
      setMenu(null);
      return;
    }
    const rect = e.currentTarget.getBoundingClientRect();
    const menuWidth  = 180;
    const menuHeight = 140;
    let top  = rect.bottom + 6;
    let left = rect.right - menuWidth;
    // agar neeche jagah kam ho to menu upar khule
    if (top + menuHeight > window.innerHeight) {
      top = rect.top - menuHeight - 6;
    }
    if (left < 8) left = 8;
    setMenu({ id, top, left });
  };

  const handleStatusChange = (id, newStatus) => {
    setMenu(null);
    const formData = new FormData();
    formData.append('id', id);
    formData.append('status', newStatus);
    axios.post(`${baseUrl}/admin/users/updateStatus`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    .then((res) => {
      if (res.data.success === true) {
        setUsers((prev) => prev.map((u) => (u.id === id ? { ...u, status: newStatus } : u)));
      }
    })
    .catch((err) => console.log(err));
  };

  const filteredUsers = users.filter((user) => {
    const matchesSearch =
      user.firstName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.lastName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.email?.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus =
      statusFilter === 'all' || user.status === statusFilter;
    return matchesSearch && matchesStatus;
  });

  return (
    <AdminLayout>
    <div className="um-users-management">
      <Container fluid>

        {/* Page Header */}
        <div className="um-page-header">
          <div className="um-page-icon">👥</div>
          <div className="um-header-content">
            <h2 className="um-page-title">All Users</h2>
            <p className="um-page-subtitle">Manage all registered users</p>
          </div>
        </div>

        {/* Stats Cards */}
        <Row className="um-stats-row g-4 mb-4">
          <Col xl={3} lg={6} md={6} sm={12}>
            <Card className="um-stat-card um-stat-blue">
              <Card.Body className="um-stat-body">
                <div className="um-stat-icon">👥</div>
                <div className="um-stat-info">
                  <h3 className="um-stat-value">{users.length}</h3>
                  <p className="um-stat-label">Total Users</p>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col xl={3} lg={6} md={6} sm={12}>
            <Card className="um-stat-card um-stat-green">
              <Card.Body className="um-stat-body">
                <div className="um-stat-icon">✅</div>
                <div className="um-stat-info">
                  <h3 className="um-stat-value">{users.filter(u => u.status === 'active').length}</h3>
                  <p className="um-stat-label">Active Users</p>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col xl={3} lg={6} md={6} sm={12}>
            <Card className="um-stat-card um-stat-purple">
              <Card.Body className="um-stat-body">
                <div className="um-stat-icon">💤</div>
                <div className="um-stat-info">
                  <h3 className="um-stat-value">{users.filter(u => u.status === 'inactive').length}</h3>
                  <p className="um-stat-label">Inactive Users</p>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col xl={3} lg={6} md={6} sm={12}>
            <Card className="um-stat-card um-stat-red">
              <Card.Body className="um-stat-body">
                <div className="um-stat-icon">🚫</div>
                <div className="um-stat-info">
                  <h3 className="um-stat-value">{users.filter(u => u.status === 'blocked').length}</h3>
                  <p className="um-stat-label">Blocked</p>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Main Table Card */}
        <Card className="um-content-card">
          <Card.Body className="um-card-body">

            {/* Filters */}
            <Row className="um-filters-row g-3 mb-4">
              <Col lg={4} md={6} sm={12}>
                <div className="um-search-wrapper">
                  <FaSearch className="um-search-icon" />
                  <Form.Control
                    type="text"
                    placeholder="Search by name or email..."
                    className="um-search-input"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
              </Col>
              <Col lg={3} md={6} sm={12}>
                <div className="um-filter-wrapper">
                  <FaFilter className="um-filter-icon" />
                  <Form.Select
                    className="um-filter-select"
                    value={statusFilter}
                    onChange={(e) => setStatusFilter(e.target.value)}
                  >
                    <option value="all">All Status</option>
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                    <option value="blocked">Blocked</option>
                  </Form.Select>
                </div>
              </Col>
              <Col lg={2} md={6} sm={12}>
                <div className="um-results-count">
                  <span className="um-count-text">
                    Showing {filteredUsers.length} of {users.length}
                  </span>
                </div>
              </Col>
            </Row>

            {/* Table */}
            <div className="um-table-wrapper">
              {pageLoading ? (
                <div style={{ textAlign: "center", padding: "40px 0" }}>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                  Loading...
                </div>
              ) : (
                <Table responsive className="um-table">
                  <thead className="um-table-head">
                    <tr>
                      <th className="um-th">ID</th>
                      <th className="um-th">Name</th>
                      <th className="um-th">Email</th>
                      <th className="um-th">Status</th>
                      <th className="um-th">Join Date</th>
                      <th className="um-th">Actions</th>
                    </tr>
                  </thead>
                  <tbody className="um-table-body">
                    {filteredUsers.length > 0 ? (
                      filteredUsers.map((user) => (
                        <tr key={user.id} className="um-table-row">
                          <td className="um-td um-td-id">
                            <span className="um-id-badge">#{user.id.toString().padStart(2, '0')}</span>
                          </td>
                          <td className="um-td">
                            <div className="um-user-info">
                              <div className="um-user-avatar">👤</div>
                              <span className="um-user-name">{user.firstName} {user.lastName}</span>
                            </div>
                          </td>
                          <td className="um-td um-td-email">{user.email}</td>
                          <td className="um-td">
                            <Badge
                              bg={
                                user.status === 'active'   ? 'success' :
                                user.status === 'blocked'  ? 'danger'  : 'secondary'
                              }
                              className="um-role-badge"
                            >
                              {user.status}
                            </Badge>
                          </td>
                          <td className="um-td um-td-date">{user.created_at?.slice(0, 10)}</td>
                          <td className="um-td">
                            <button
                              type="button"
                              className="um-dots-btn"
                              onClick={(e) => openMenu(e, user.id)}
                            >
                              <FaEllipsisV />
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="6" className="um-no-data">
                          <div className="um-no-data-content">
                            <span className="um-no-data-icon">🔍</span>
                            <p className="um-no-data-text">No users found</p>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              )}
            </div>

          </Card.Body>
        </Card>

      </Container>
    </div>

    {/* 3-dots menu: document.body mein render hota hai, isliye hamesha button ke neeche khulta hai */}
    {menu && ReactDOM.createPortal(
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          position: 'fixed',
          top: menu.top,
          left: menu.left,
          width: 180,
          background: '#ffffff',
          borderRadius: 12,
          boxShadow: '0 10px 30px rgba(0, 0, 0, 0.15)',
          padding: 8,
          zIndex: 2000,
        }}
      >
        <MenuItem label="Set Active"   onClick={() => handleStatusChange(menu.id, 'active')}   />
        <MenuItem label="Set Inactive" onClick={() => handleStatusChange(menu.id, 'inactive')} />
        <MenuItem label="Block User"   color="#dc3545" onClick={() => handleStatusChange(menu.id, 'blocked')} />
      </div>,
      document.body
    )}
    </AdminLayout>
  );
};

export default AllUsers;